// extracted by mini-css-extract-plugin
export var actions = "_tg-4";
export var item = "_tg-1";
export var price = "_tg-3";
export var quantity = "_tg-2";
export var table = "_tg-0";